module.exports = __webpack_public_path__ + "static/media/bus.5f33433d.svg";